import React, { useEffect, useState, useMemo } from "react";
import axios from "axios";
import TableComponent from "../components/TableComponent";
import { Container, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { formatDate } from "../utils/helpers";

import { useDispatch } from "react-redux";
import { setSampleCode } from "../redux/sampleSlice";
import { useAuth } from "../context/AuthContext";
import { FaFileExcel } from "react-icons/fa";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";


import { Modal, Form } from "react-bootstrap";

const API_URL = process.env.REACT_APP_API_URL;

function Patient_report_sample_id_wise() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { user } = useAuth();

    const [dataEntry, setDataEntry] = useState([]);

    ///////////////////////////
    const [showModal, setShowModal] = useState(false);
    const [password, setPassword] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [error, setError] = useState("");
    ////////////////////////////
    // Fetch Data
    useEffect(() => {
        const token = localStorage.getItem("token");
        if (!token) return;

        axios
            .get(`${API_URL}/patient_report_sample_id_wise`, {
                headers: { Authorization: `Bearer ${token}` },
            })
            .then((res) => {
                setDataEntry(res.data.literatures || []);
            })
            .catch((err) => console.error("Error fetching data:", err));
    }, []);

    // Role-based filtering
    const filteredData = useMemo(() => {
        if (!user) return [];

        // Admin role = "1" → see all
        if (user.role === "1") return dataEntry;

        // Normal user role = "0" → see only own created records
        if (user.role === "0") {
            return dataEntry.filter(
                (item) => item.user_id === user.uid
            );
        }

        return [];
    }, [dataEntry, user]);

    const openPasswordModal = (sample_master_id) => {
        setSelectedId(sample_master_id);
        setPassword("");
        setError("");
        setShowModal(true);
    };

    const verifyPassword = async () => {
        try {
            const token = localStorage.getItem("token");

            const res = await axios.post(
                `${API_URL}/verify-password`,
                { password, uid: user?.uid },
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );

            if (res.data.success) {
                setShowModal(false);
                navigate(`/Update_Male_Details/${selectedId}`);
            } else {
                setError("Incorrect password");
            }
        } catch (err) {
            setError("Incorrect password");
        }
    };
    // const handleEdit = (sample_master_id) => {
    //     navigate(`/Update_Male_Details/${sample_master_id}`);
    // };

    const handlePrint = (sample_master_id) => {
        window.open(`/All_Report_download/${sample_master_id}`, "_blank");
    };
    //////////////////////////////////////////////////////////////////////////////
    const handlePrint_Excel = async (male_id) => {
        try {


            const formatValue = (key, value) => {

                const num = Number(value);

                const smokingMap = {
                    1: "No",
                    2: "Former Smoker",
                    3: "Current Smoker (Daily)",
                    4: "Current Smoker (Occasional)",
                    5: "Data Not Available"
                };

                const tobaccoMap = {
                    1: "No",
                    2: "Former User",
                    3: "Current User (Active)",
                    4: "Current User (Occasional)",
                    5: "Data Not Available"
                };

                const yesNoMap = {
                    0: "No",
                    1: "Yes",
                    2: "Data Not Available"
                };

                const alcoholMap = {
                    1: "No",
                    2: "Former Drinker",
                    3: "Current Drinker (Active)",
                    4: "Current Drinker (Occasional)",
                    5: "Data Not Available"
                };

                if (key === "Smoking") return smokingMap[num] || "Unknown";
                if (key === "Chewing_Tobacco") return tobaccoMap[num] || "Unknown";
                if (key === "Alcohol") return alcoholMap[num] || "Unknown";

                if (
                    [
                        "Diabetes",
                        "Hypertension",
                        "Mumps",
                        "Trauma",
                        "Surgeries",
                        "Hernia",
                        "Varicocele",
                        "Undescended_Testes",
                        "Vasectomy",
                        "STD_Genital_Discharges"
                    ].includes(key)
                ) {
                    return yesNoMap[num] || "Unknown";
                }

                return value ?? "";
            };
            const token = localStorage.getItem("token");
            if (!token) return;

            const res = await axios.get(
                `${API_URL}/partner_details_all_data_id_wise/${male_id}`,
                { headers: { Authorization: `Bearer ${token}` } }
            );

            const data = res.data.partner_data;
            if (!data) return;

            let excelData = [];
            let count = 1;

            // Fields you don't want in Excel
            const skipFields = [
                "id",
                "sample_id",
                "sample_master_id",
                "created_by",
                "created_date"
            ];

            const formatLabel = (text) => {
                return text
                    .replace(/_/g, " ")
                    .replace(/\b\w/g, l => l.toUpperCase());
            };

            Object.entries(data).forEach(([sectionName, sectionValue]) => {

                // If ARRAY (like followups, hormonal)
                if (Array.isArray(sectionValue)) {

                    sectionValue.forEach((item, index) => {

                        Object.entries(item).forEach(([key, value]) => {

                            if (skipFields.includes(key)) return;

                            excelData.push({
                                "Sr No": count++,
                                "Form Name": `${formatLabel(sectionName)}`,
                                "Label Name": `${formatLabel(key)}`,
                                "Value": formatValue(key, value)
                            });
                        });

                    });

                }
                // If OBJECT (male, female, models)
                else if (typeof sectionValue === "object" && sectionValue !== null) {

                    Object.entries(sectionValue).forEach(([key, value]) => {

                        if (skipFields.includes(key)) return;

                        excelData.push({
                            "Sr No": count++,
                            "Form Name": `${formatLabel(sectionName)}`,
                            "Label Name": `${formatLabel(key)}`,
                            "Value": formatValue(key, value)
                        });
                    });

                }

            });

            // Create worksheet
            const worksheet = XLSX.utils.json_to_sheet(excelData);

            worksheet["!cols"] = [
                { wch: 8 },
                { wch: 30 },
                { wch: 45 },
                { wch: 60 }
            ];

            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Full Report");

            const excelBuffer = XLSX.write(workbook, {
                bookType: "xlsx",
                type: "array",
            });

            const blob = new Blob([excelBuffer], {
                type: "application/octet-stream",
            });

            saveAs(blob, `Full_Partner_Report_${male_id}.xlsx`);

        } catch (error) {
            console.error("Excel Download Error:", error);
        }
    };
    // const handlePrint_Excel = async (male_id) => {
    //     try {
    //         const token = localStorage.getItem("token");
    //         if (!token) return;

    //         const res = await axios.get(
    //             `${API_URL}/partner_details_all_data_id_wise/${male_id}`,
    //             {
    //                 headers: { Authorization: `Bearer ${token}` },
    //             }
    //         );

    //         const data = res.data.partner_data;
    //         console.log(data);
    //         if (!data) return;

    //         let excelData = [];
    //         let count = 1;

    //         const pushObjectData = (obj, sectionName) => {
    //             if (!obj) return;

    //             Object.entries(obj).forEach(([key, value]) => {
    //                 excelData.push({
    //                     "Sr No": count++,
    //                     "Label Name": `${sectionName} - ${key.replace(/_/g, " ")}`,
    //                     "Value": value ?? ""
    //                 });
    //             });
    //         };

    //         pushObjectData(data.male, "Male");
    //         // Male Hormonal (Array)
    //         if (Array.isArray(data.male_hormonal)) {
    //             data.male_hormonal.forEach((item, index) => {
    //                 pushObjectData(item, `Male Hormonal ${index + 1}`);
    //             });
    //         }
    //         // Female
    //         pushObjectData(data.female, "Female");



    //         // Female Hormonal (Array)
    //         if (Array.isArray(data.female_hormonal)) {
    //             data.female_hormonal.forEach((item, index) => {
    //                 pushObjectData(item, `Female Hormonal ${index + 1}`);
    //             });
    //         }

    //         pushObjectData(data.followup_14days, "follow Up 14 days");

    //         // Create worksheet
    //         const worksheet = XLSX.utils.json_to_sheet(excelData);
    //         worksheet["!cols"] = [
    //             { wch: 8 },   // Sr No column width 
    //             { wch: 35 },  // Label Name column width
    //             { wch: 50 },  // Value column width
    //         ];

    //         const workbook = XLSX.utils.book_new();
    //         XLSX.utils.book_append_sheet(workbook, worksheet, "Report");

    //         const excelBuffer = XLSX.write(workbook, {
    //             bookType: "xlsx",
    //             type: "array",
    //         });

    //         const blob = new Blob([excelBuffer], {
    //             type: "application/octet-stream",
    //         });

    //         saveAs(blob, `Partner_Report_${male_id}.xlsx`);

    //     } catch (error) {
    //         console.error("Excel Download Error:", error);
    //     }
    // };


    ////////////////////////////////////////////////////////////////////////////////


    const columns = [
        {
            key: "index",
            label: "Sr. No",
            format: (_, __, index) => index + 1,
        },
        {
            key: "male_sample_id",
            label: "Sample Id",
            align: "left",
            format: (_, row) => (
                <span
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                        dispatch(setSampleCode(row.male_sample_id))
                    }
                >
                    {row.male_sample_id}
                </span>
            ),
        },
        { key: "male_crn", label: "Male CRN" },
        { key: "female_crn", label: "Female CRN" },
        {
            key: "center",
            label: "Center Name / Code",
            format: (_, row) =>
                `${row.center_name || ""} / ${row.center_code || ""}`,
        },
        { key: "created_by", label: "Created By" },
        {
            key: "created_date",
            label: "Created Date",
            format: formatDate,
        },
        {
            key: "action",
            label: "Action",
            format: (_, row) => (
                <>
                    <Button
                        size="sm"
                        className="me-2"
                        onClick={() => {
                            dispatch(setSampleCode(row.male_sample_id));
                            openPasswordModal(row.sample_master_id);
                        }}
                    >
                        Edit
                    </Button>

                    <Button
                        size="sm"
                        variant="info" className="me-2"
                        onClick={() => {
                            dispatch(setSampleCode(row.male_sample_id));
                            handlePrint(row.sample_master_id);
                        }}
                    >
                        <i className="fa fa-print"></i>
                    </Button>
                    <Button
                        size="sm"
                        variant="success" onClick={() => { handlePrint_Excel(row.sample_master_id); }}

                    >
                        <FaFileExcel />
                    </Button>
                </>
            ),
        },
    ];

    return (
        <Container className="mt-4">
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h3>Patient Report List</h3>
            </div>

            <TableComponent
                columns={columns}
                data={filteredData}
                rowsPerPage={10}
                maxHeight={400}
                headerClass="table-dark"
            />
            <Modal
                show={showModal}
                onHide={() => setShowModal(false)}
                centered
                backdrop="static"
                keyboard={false}
                dialogClassName="soft-modal"
            >
                <Modal.Header closeButton style={{ borderBottom: "none" }}>
                    <Modal.Title style={{ fontWeight: 600, fontSize: "1.3rem" }}>
                        Confirm Password
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body style={{ padding: "2rem 2rem 1rem 2rem" }}>
                    <Form.Group>
                        <Form.Label style={{ fontWeight: 500, fontSize: "0.95rem", color: "#555" }}>
                            Enter your password
                        </Form.Label>
                        <Form.Control
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="" autoComplete="off"
                            style={{
                                borderRadius: "12px",
                                border: "1px solid #ddd",
                                padding: "10px 15px",
                                fontSize: "0.95rem",
                                boxShadow: "inset 0 2px 5px rgba(0,0,0,0.05)",
                            }}
                        />
                    </Form.Group>
                    {error && (
                        <p
                            className="text-danger mt-2"
                            style={{ fontSize: "0.9rem", fontWeight: 500 }}
                        >
                            {error}
                        </p>
                    )}
                </Modal.Body>

                <Modal.Footer style={{ borderTop: "none", padding: "1rem 2rem 2rem 2rem" }}>
                    <Button
                        variant="outline-secondary"
                        onClick={() => setShowModal(false)}
                        style={{
                            borderRadius: "10px",
                            padding: "8px 18px",
                            fontWeight: 500,
                            boxShadow: "0 3px 6px rgba(0,0,0,0.08)",
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="primary"
                        onClick={verifyPassword}
                        style={{
                            borderRadius: "10px",
                            padding: "8px 20px",
                            fontWeight: 600,
                            background: "linear-gradient(135deg,#6a9fff,#5a86ff)",
                            border: "none",
                            boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                        }}
                    >
                        Verify
                    </Button>
                </Modal.Footer>
            </Modal>


            <style>
                {`
.soft-modal .modal-content {
    border-radius: 20px;
    padding: 0;
    box-shadow: 0 10px 30px rgba(0,0,0,0.12);
    border: none;
    overflow: hidden;
}
`}
            </style>
        </Container>
    );
}

export default Patient_report_sample_id_wise;